export default __webpack_public_path__ + "a371b0ef9934f9750f34fa5a3732c10c.gif";